import { POST } from './HTTP';

export interface V1AuditIssue {
    severity: 'error' | 'warning';
    code: string;
    message: string;
    context?: string;
}

export interface V1LessonSetAuditEntry {
    journeySetId: string;
    title: string;
    categoryKey?: string;
    templateId: string;
    templateName?: string;
    journeyCount: number;
    mediaAssetCount: number;
    missingMediaCount: number;
    success: boolean;
    auditedAt: string;
    issues: V1AuditIssue[];
}

export interface V1ExportAuditReport {
    schemaVersion: string;
    generatedAt: string;
    appInstanceId: string;
    subdomain: string;
    entries: V1LessonSetAuditEntry[];
}

export interface V1LessonSetExportItemResult {
    journeySetId: string;
    title: string;
    success: boolean;
    error?: string;
    warnings: string[];
    packagePath?: string;
    audit?: V1LessonSetAuditEntry;
}

export interface V1ExportBatchResult {
    packagePrefix: string;
    manifest: {
        schemaVersion: string;
        exportedAt: string;
        appInstanceId: string;
        subdomain: string;
        templateCount: number;
        lessonSetCount: number;
        warnings: string[];
    };
    auditReport?: V1ExportAuditReport;
    lessonSets: V1LessonSetExportItemResult[];
    warnings: string[];
}

export function auditSelectedJourneySets(
    appInstanceId: string,
    journeySetIds: string[]
): Promise<V1ExportAuditReport> {
    return POST(`/migration/export/instances/${appInstanceId}/journey-sets/audit`, {
        journeySetIds,
    });
}

export function exportSelectedJourneySets(
    appInstanceId: string,
    journeySetIds: string[]
): Promise<V1ExportBatchResult> {
    return POST(`/migration/export/instances/${appInstanceId}/journey-sets`, {
        journeySetIds,
    });
}
